module.exports = "/_next/static/images/game-1-phone-gallery-08-25-1545-506ccab2e9874c18ec352bc906189b5e.jpg";